/**
 * @prettier
 */
import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { app2 } from 'src/app2';
import { Select } from 'src/components/Select';
import { CostTypes } from 'src/constants/CostType';
import { translate } from 'src/i18n/translate';
import { useAction } from 'src/utils/react/useAction';

export function FilterCostType({ disabled, onChange }: Props): React.ReactElement {
    const classes = useStyles();
    const setReportsCostType = useAction(app2.actions.setReportsCostType);

    const handleChangeColumns = (mode: any) => {
        setReportsCostType(mode[0]);
    };

    const options = Object.values(CostTypes).map((costType) => ({
        label: translate(`CostTypes.${String(costType)}`),
        value: String(costType),
    }));

    return <Select label={translate('Cost Type')} name='CostType' labelAsPlaceholder options={options} onChange={handleChangeColumns} disabled={disabled} classes={{ button: classes.button }} />;
}

const useStyles = makeStyles((theme) => ({
    button: {
        border: `1px solid ${theme.palette.border.primary} !important`,
        backgroundColor: 'transparent',
        color: `${theme.palette.text.secondary} !important`,
        '&:hover': {
            border: `1px solid #8A95A5 !important`,
            backgroundColor: 'transparent !important',
        },
    },
}));

type Props = {
    disabled?: boolean;
    onChange?: any;
};
